import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: {
          /* Login */
          loginHello: '¡Hola!',
          loginTitle: 'Hagamos un TEDxperiment',

          disclaimerWhy: '¿Por qué tengo que iniciar sesión?',
          disclaimerText:
            'Es necesario iniciar sesión para evitar que repitas un experimento y tomemos una muestra dos veces. Todos los datos están anonimizados, son usados exclusivamente para investigación científica y son publicados de manera abierta y puestos a disposición de la comunidad científica conjuntamente con los papers.',

          loginFacebook: 'Ingresar con <1>Facebook</1>',
          loginGoogle: 'Ingresar con <1>Google</1>',

          loginEmailInput: 'Email',
          loginPasswordInput: 'Contraseña',
          loginForgotPasswordLink: 'Olvidé mi contrseña',

          loginButton: 'Ingresar',
          loginSignupQuestion: '¿Todavía no tenés cuenta?',
          loginSignupLink: 'Crear cuenta',

          /* Signup */
          signupTitle: 'Creá tu cuenta',
          signupNameInput: 'Nombre',
          signupEmailInput: 'Email',
          signupPasswordInput: 'Contraseña',
          signupRepeatPasswordInput: 'Repetir contraseña',

          signupButton: 'Crear cuenta',

          signupLoginQuestion: '¿Ya tenés cuenta?',
          signupLoginLink: 'Ingresar',

          /* Recover */
          recoverTitle: 'Recuperar contraseña',
          recoverText:
            'Ingresá tu mail y te contactamos para cambiar tu contraseña.',

          recoverEmailInput: 'Email',

          recoverButton: 'Recuperar',

          recoverSignupQuestion: '¿Todavía no tenés cuenta?',
          recoverSignupLink: 'Crear cuenta',

          recoverMailSent: '¡Te enviamos un email!',
          recoverMailSentText:
            'Revisá tu casilla de correo y hace click en el enlace que te mandamos para crear una nueva contraseña.',

          /* New Password */
          newPasswordTitle: 'Crear nueva contraseña',
          newPasswordPasswordInput: 'Nueva contraseña',
          newPasswordConfirmPasswordInput: 'Repetir nueva contraseña',
          newPasswordButton: 'Crear contraseña',

          /* Terms */
          termsTitle: 'Pandemia moral',
          termsText1:
            'Te invitamos a ser parte de una investigación que estamos llevando a cabo en todo el mundo para estudiar nuestras intuiciones y decisiones morales en este contexto global tan particular que atraviesa la humanidad. Este experimento es parte de un estudio que estamos haciendo entre muchos TEDx alrededor del mundo, El Gato y La Caja y el Laboratorio de Neurociencia de la Universidad Torcuato Di Tella.',
          termsText2:
            'A continuación vamos a presentarte diferentes dilemas. Algunos pueden emocionarnos, o incluso angustiarnos. Creemos que el ejercicio de reflexionar sobre ellos ayuda a conocernos mejor y a ordenar nuestro pensamiento.',
          termsText3:
            'La duración total es de unos 10 minutos, tu participación es absolutamente voluntaria y puede finalizar cuando lo desees. No esperamos ningún tipo de inconveniente o riesgo por participar. Los datos de identidad son confidenciales, están anonimizados y encriptados y serán usados exclusivamente para investigación.',
          termsText4:
            'Si tenés cualquier tipo de duda, nos mandás un mail a <1>labs@elgatoylacaja.com</1>. Si la pregunta nos excede, o querés hacer otro tipo de comentario, podés contactarte con el Comité de Ética en Investigación, Centro de Educación Médica e Investigaciones Clínicas “Norberto Quirno”. Hospital Universitario sede Saavedra, Av. Galván 4102. Ciudad de Buenos Aires, (C1425DQK) - República Argentina. Tel: +54911 5299-0100, interno 2879.',
          termsText5:
            'Apenas esté el análisis de estos datos vamos a publicar los resultados en <1>www.elgatoylacaja.com.ar/labs</1> para conversar sobre lo que aprendimos gracias a tu participación.',
          termsCheckboxLabel:
            'Leí, entendí todo y estoy de acuerdo en participar.',
          termsAllowNewsLabel:
            'Quiero recibir novedades sobre los resultados de estas investigaciones y nuevos experimentos.',
          termsButton: 'Empezar',
          termsError: 'Es necesario aceptar los términos para continuar',

          /* Intro */
          introTitle:
            'A continuación te vamos a mostrar 6 escenarios imaginarios y hacerte algunas preguntas.',
          introText:
            'Por favor, leelos con atención y respondé qué opinás en cada caso. Podés ubicarte en el lugar de la escala que creas que mejor representa tu posición.',
          introButton: 'Empezar',

          /* Situations */
          situationTitle1: 'Imaginá el siguiente escenario:',
          situationTitle2: 'Siguiente escenario:',
          situationTitle3: 'Siguiente escenario:',
          situationTitle4: 'Siguiente escenario:',
          situationTitle5: 'Siguiente escenario:',
          situationTitle6: 'Último escenario:',
          situationTitle7: 'Siguiente escenario:',
          situationTitle8: 'Siguiente escenario:',
          situationTitle9: 'Último escenario:',
          whatDoYouThink: '¿Qué opinás?',

          wrong: 'Incorrecto',
          right: 'Correcto',

          confidenceQuestion: '¿Cuánto confias en tu respuesta?',
          personalEmotionalityQuestion:
            'Imaginate que se da esta situación y tenés que decidir qué hacer, ¿cuánta angustia sentirías?',
          entityEmotionalityQuestion:
            'Imaginate que se da esta situación y vos sos la persona responsable de decidir qué se va a hacer, ¿cuánta angustia sentirías?',

          nothing: 'Nada',
          alot: 'Mucho',
          notAnxious: 'Nada',
          anxious: 'Mucha',

          situationsButton: 'Siguiente',

          situation1_1:
            'Los respiradores artificiales se han convertido en un recurso crítico y un cuello de botella para los médicos en muchos países. Un comité de ética está considerando el criterio para decidir quienes accederán a este recurso y quiénes no. Una primera opción es asignar los respiradores según el orden de llegada a la guardia médica. La segunda opción sugiere que los pacientes más jóvenes (menores a 30 años) deben tener prioridad frente a los mayores, incluso si las chances de recuperación fuesen las mismas.',
          situation1_v1:
            'El comité de ética decide implementar la segunda opción.',
          situation1_1_question: 'Implementar la segunda opción es:',
          situation1_v2:
            'Imaginá la misma situación, pero ahora un paciente de 75 años ya está conectado a un respirador artificial. Un paciente de 30 años acaba de llegar a la sala de emergencia y ya no quedan más respiradores. El comité decide quitarle el respirador al paciente de 75 y dárselo al de 30.',
          situation1_2_question: 'Esta acción es:',
          situation1_v3:
            'Por último, el comité ahora decide que los trabajadores de la salud, como se infectaron ayudando a otra gente y son necesarios para seguir curando, deben tener prioridad en el acceso a respiradores por sobre cualquier otro paciente, sin importar la edad.',
          situation1_3_question: 'Esta decisión es:',

          situation2_1:
            'Imaginemos que podemos viajar en el tiempo e ir a un momento en el que la pandemia todavía no había explotado en el mundo. Una nueva tecnología permite que los gobiernos recolecten información personal acerca de nuestros movimientos y las personas con las que tuvimos contacto físico. Los gobiernos también pueden acceder a datos biométricos como nuestra temperatura y frecuencia respiratoria. Esta información permite identificar personas en riesgo de tener COVID-19 y limitar la propagación del virus seleccionando a quiénes aislar y a quiénes no.',
          situation2_2:
            'El gobierno del país donde vivís evalúa un plan de uso esta tecnología pero entiende que desprotege los datos personales de sus ciudadanos y decide no aprobarlo.',
          situation2_question: 'No aprobar el plan es:',

          situation3_1:
            'El futuro cercano de nuestras sociedades es incierto y todavía no sabemos cómo nos vamos a organizar cuando salgamos de períodos de cuarentena estricta. Esto es, entre otras cosas, porque desconocemos el ritmo de mutación del virus, su variación estacional, la probabilidad de re-contagio, y el grado de inmunidad que podremos alcanzar. Es probable que las sociedades lleguen a un compromiso entre minimizar riesgos a la salud y preservar nuestros estilos de vida deseados.',
          situation3_v1:
            'Sabiendo esto, un gobierno decide prohibir todo tipo de reuniones públicas (incluyendo restaurantes, bares, conciertos, cines y teatros) hasta que se encuentre una vacuna.',
          situation3_1_question: 'La decisión del gobierno es:',
          situation3_v2:
            'Un gobierno decide que, hasta que se encuentre una vacuna, toda persona que quiera viajar a otra ciudad debe pedirle un permiso oficial a una oficina pública del Estado.',
          situation3_2_question: 'Esta decisión del gobierno es:',
          situation3_v3:
            'Un gobierno decide implementar una cuarentena estricta para personas mayores a 70 años hasta que se encuentre una vacuna.',
          situation3_3_question: 'Esta decisión del gobierno es:',

          situation4_1:
            'Uno de tus amigos cercanos tiene fiebre alta y hace poco le hicieron el test de COVID-19. Las autoridades sanitarias de tu país le ordenaron que se quede en su casa en total aislamiento hasta que los resultados estén listos. Durante este período, tu amigo fue una vez a comprar comida al supermercado. Si las autoridades se enterasen de esto, tu amigo podría ir a la cárcel y tener antecedentes penales.',
          situation4_2:
            'Todavía no se sabe si el resultado del test es positivo pero decidiste llamar a la policía y contarle esta situación a las autoridades.',
          situation4_question: 'Contarle esta situación a las autoridades es:',

          situation5_1:
            'Un laboratorio tiene todos los recursos necesarios para desarrollar una vacuna para el coronavirus en tan sólo 4 semanas. Sin embargo, para hacer eso, los investigadores necesitan violar reglas éticas para el uso de animales en investigaciones científicas. En particular, los experimentos van a causar excesivo dolor y stress a cientos de roedores.',
          situation5_2:
            'El laboratorio pide un permiso excepcional para realizar estos experimentos, pero el gobierno decide rechazar este pedido.',
          situation5_question: 'La decisión tomada por el gobierno es:',

          situation6_1:
            'Muchos gobiernos les indicaron a sus ciudadanos que se queden en cuarentena en sus casas. Sin embargo, distintos países reaccionan de distinta manera a los incumplimientos de esta norma. Un gobierno decide que las personas que estén en un espacio público sin una razón válida deben ser llevadas a un centro de detención público y aisladas por 30 días.',
          situation6_question: 'La decisión tomada por el gobierno es:',

          situation7_1:
            'Varias clínicas privadas en un país compraron kits de diagnóstico de COVID-19. En un momento dado, la epidemia creció sustancialmente y el gobierno dejó de tener material suficiente para testear casos que considera urgentes.',
          situation7_2:
            'El gobierno decide expropiar por ley todos los kits de diagnóstico del país y otorgar una compensación a las clínicas que permite cubrir el costo de los materiales.',
          situation7_question: 'La decisión tomada por el gobierno es:',

          situation8_1:
            'Imaginemos que vivís en un país donde los efectos del coronavirus fueron relativamente suaves comparado con otros lugares del mundo. El gobierno acaba de anunciar el descubrimiento de una droga que resulta efectiva para curar el COVID-19. Varios otros países, donde el número de infectados sigue creciendo de modo exponencial y los efectos de la pandemia fueron más severos, desean comprar la droga.',
          situation8_2:
            'Sin embargo, el gobierno argumenta que el descubrimiento fue una inversión pública y decide prohibir la exportación de la droga, que no necesitan con urgencia en ese momento,  hasta que la enfermedad sea totalmente erradicada en el país. ',
          situation8_question: 'La decisión tomada por el gobierno es:',

          situation9_1:
            'Un tren fuera de control se dirige a toda velocidad por las vías hacia cinco personas que morirán si el tren sigue su curso. Vos estás a un costado de las vías, pero demasiado lejos para avisarles. Al lado tuyo hay una palanca de control que puede redirigir el tren hacia otra vía donde hay una sola persona.',
          situation9_2:
            'Si decidís accionar la palanca, eso provocará la muerte de una persona, pero el tren no seguirá su curso y habrás salvado la vida de otras cinco personas.',
          situation9_question: 'Accionar la palanca es:',

          situation10_1:
            'Un tren fuera de control se dirige a toda velocidad por las vías hacia cinco personas, que morirán si el tren sigue su curso. Vos estás a un costado de las vías, pero demasiado lejos para avisarles. Al lado tuyo hay otra persona que, en caso de que caiga a las vías, eso hará que el tren descarrile.',
          situation10_2:
            'Si decidís empujar a esta persona a las vías, eso provocará su muerte, pero el tren no seguirá su curso y habrás salvado la vida de otras cinco personas.',
          situation10_question: 'Empujar a la persona a las vías es:',

          /* Skip */
          skipTitle: '¡Perfecto! Completaste los 6 escenarios.',
          skipText:
            '¿Querés leer 3 escenarios más o preferís saltar al último paso?',
          skipReadMoreButton: 'Leer escenarios',
          skipLink: 'Saltar al último paso',

          /* Oxford */
          oxfordTitle: 'Últimas preguntas',
          oxfordText: 'Marcá cuán de acuerdo estás con las siguientes frases.',

          oxford1:
            'Si, durante una emergencia, la única manera de salvar la vida de otra persona es cortándose una pierna, entonces uno está moralmente obligado a hacer eso.',
          oxford2:
            'Desde el punto de vista moral, deberíamos sentirnos obligados a donar uno de nuestro riñones a una persona con insuficiencia renal dado que no necesitamos dos riñones para vivir y podemos ser saludables con uno solo. ',
          oxford3:
            'Desde una perspectiva moral, las personas deberían preocuparse igualmente por el bienestar de todos los seres humanos del planeta; no deberían favorecer el bienestar de las personas que son más cercanas, ya sea física o emocionalmente.',
          oxford4:
            'No ayudar a una persona está igual de mal que lastimarla activamente uno mismo.',
          oxford5:
            'Es moralmente incorrecto quedarse con plata que uno no necesita si uno la puede donar a causas que provean ayuda efectiva para personas que se beneficiarían mucho.',
          oxford6:
            'Es moralmente aceptable lastimar a una persona inocente si lastimarla es un medio necesario para ayudar a varias otras personas inocentes.',
          oxford7:
            'Si la única manera de asegurar el bienestar y la felicidad general de las personas es mediante la opresión política, limitada a un período corto en el tiempo, entonces se debe usar la opresión política.',
          oxford8:
            'Es permisible torturar a una persona inocente si esto fuese necesario para obtener información que evite la explosión de una bomba que mataría a cientos de personas.',
          oxford9:
            'A veces es moralmente necesario que las personas inocentes mueran como daño colateral, si al final se logra salvar la vida de más personas.',

          oxfordDisagree: 'Totalmente en desacuerdo',
          oxfordNeither: 'Ni en desacuerdo ni de acuerdo',
          oxfordAgree: 'Totalmente de acuerdo',

          oxfordButton: 'Siguiente',

          /* Regressors */
          regressorsTitle: 'Para terminar:',
          regressorsAge: 'Edad',
          regressorsGenre: 'Género:',
          regressorsGenrePlaceholder: 'Elegí una opción',
          regressorsNationality: 'Nacionalidad',
          regressorsCountry: '¿En qué país estás?',
          regressorsCountryPlaceholder: 'País',

          regressorsCovidQuestion:
            'Si conocés a alguien que tuvo o tenga COVID 19, marcá la o las opciones correspondientes:',
          regressorsCovidOption1: 'Yo tuve o tengo.',
          regressorsCovidOption2: 'Una persona cercana a mí tuvo o tiene.',
          regressorsCovidOption3:
            'Una persona que conozco, no muy cercana, tuvo o tiene.',
          regressorsCovidOption4: 'No conozco a nadie que haya tenido o tenga.',

          regressorsButton: 'Terminar',

          /* Thanks */
          thanksTitle: '¡Gracias por participar!',
          thanksLightText1:
            'En esta coyuntura tan particular, donde las sociedades se enfrentan a dilemas como los que acabás de atravesar, es importante entender la naturaleza de nuestra moral individual y colectiva. Tu participación ha sido fundamental en esta búsqueda.',
          thanksLightText2:
            'Estos problemas no tienen respuestas indefectiblemente correctas o incorrectas ni soluciones únicas. Creemos que el ejercicio de reflexionar sobre ellos ayuda a conocernos mejor y a ordenar nuestro pensamiento, de manera de poder tomar posiciones y decisiones conscientes e informadas.',
          thanksText:
            '¡Cuantas más personas participen, <1>mayor potencia tendrán los resultados!</1>',

          thanksContinue: 'Más experimentos pandémicos',

          /* Done */
          doneTitle: 'Gracias',
          doneLightText:
            'El experimento puede hacerse sólo una vez y ya tenemos tus respuestas.',

          doneShareText: 'No dejes de compartir ;)',
          doneContinue: 'Más experimentos pandémicos',

          /* Share */
          share: '<0>Compartí</0> el experimento',
          shareFacebookButton: 'Compartí en tu muro',
          shareTwitterButton: 'Escribí un tweet',

          /* Error Messages */
          errorFacebookLogin:
            'Hubo un error al ingresar con facebook, al reintentar revisa los permisos necesarios',
          errorGoogleLogin: 'Hubo un error al ingresar con google',

          errorMoveSlider: 'Es necesario mover el slider',
          errorMailUsed: 'Este mail ya está en uso',
          errorRequiredField: 'Este campo es requerido',
          errorMissingField: 'Falta responder alguna consigna',
          errorInformationRequired: 'Este campo es requerido',
          answerBeforeMovingOn: 'Falta responder alguna consigna',
          errorUserNotFound: 'No existe un usuario con ese email',
          errorInvalidEmail: 'No es un email válido',
          errorPasswordDontMatch: 'Las contraseñas no coinciden',
          errorWrongPassword: 'Contraseña incorrecta',
        },
      },
      en: {
        translation: {
          /* Login */
          loginHello: '¡Hola!',
          loginTitle: 'Hagamos un TEDxperiment',

          disclaimerWhy: '¿Por qué tengo que iniciar sesión?',
          disclaimerText:
            'Es necesario iniciar sesión para evitar que repitas un experimento y tomemos una muestra dos veces. Todos los datos están anonimizados, son usados exclusivamente para investigación científica y son publicados de manera abierta y puestos a disposición de la comunidad científica conjuntamente con los papers.',

          loginFacebook: 'Ingresar con <1>Facebook</1>',
          loginGoogle: 'Ingresar con <1>Google</1>',

          loginEmailInput: 'Email',
          loginPasswordInput: 'Contraseña',
          loginForgotPasswordLink: 'Olvidé mi contrseña',

          loginButton: 'Ingresar',
          loginSignupQuestion: '¿Todavía no tenés cuenta?',
          loginSignupLink: 'Crear cuenta',

          /* Signup */
          signupTitle: 'Creá tu cuenta',
          signupNameInput: 'Nombre',
          signupEmailInput: 'Email',
          signupPasswordInput: 'Contraseña',
          signupRepeatPasswordInput: 'Repetir contraseña',

          signupButton: 'Crear cuenta',

          signupLoginQuestion: '¿Ya tenés cuenta?',
          signupLoginLink: 'Ingresar',

          /* Recover */
          recoverTitle: 'Recuperar contraseña',
          recoverText:
            'Ingresá tu mail y te contactamos para cambiar tu contraseña.',

          recoverEmailInput: 'Email',

          recoverButton: 'Recuperar',

          recoverSignupQuestion: '¿Todavía no tenés cuenta?',
          recoverSignupLink: 'Crear cuenta',

          recoverMailSent: '¡Te enviamos un email!',
          recoverMailSentText:
            'Revisá tu casilla de correo y hace click en el enlace que te mandamos para crear una nueva contraseña.',

          /* New Password */
          newPasswordTitle: 'Crear nueva contraseña',
          newPasswordPasswordInput: 'Nueva contraseña',
          newPasswordConfirmPasswordInput: 'Repetir nueva contraseña',
          newPasswordButton: 'Crear contraseña',

          /* Terms */
          termsTitle: 'Pandemia moral',
          termsText1:
            'Te invitamos a ser parte de una investigación que estamos llevando a cabo en todo el mundo para estudiar nuestras intuiciones y decisiones morales en este contexto global tan particular que atraviesa la humanidad. Este experimento es parte de un estudio que estamos haciendo entre muchos TEDx alrededor del mundo, El Gato y La Caja y el Laboratorio de Neurociencia de la Universidad Torcuato Di Tella.',
          termsText2:
            'A continuación vamos a presentarte diferentes dilemas. Algunos pueden emocionarnos, o incluso angustiarnos. Creemos que el ejercicio de reflexionar sobre ellos ayuda a conocernos mejor y a ordenar nuestro pensamiento.',
          termsText3:
            'La duración total es de unos 10 minutos, tu participación es absolutamente voluntaria y puede finalizar cuando lo desees. No esperamos ningún tipo de inconveniente o riesgo por participar. Los datos de identidad son confidenciales, están anonimizados y encriptados y serán usados exclusivamente para investigación.',
          termsText4:
            'Si tenés cualquier tipo de duda, nos mandás un mail a <1>labs@elgatoylacaja.com</1>. Si la pregunta nos excede, o querés hacer otro tipo de comentario, podés contactarte con el Comité de Ética en Investigación, Centro de Educación Médica e Investigaciones Clínicas “Norberto Quirno”. Hospital Universitario sede Saavedra, Av. Galván 4102. Ciudad de Buenos Aires, (C1425DQK) - República Argentina. Tel: +54911 5299-0100, interno 2879.',
          termsText5:
            'Apenas esté el análisis de estos datos vamos a publicar los resultados en <1>www.elgatoylacaja.com.ar/labs</1> para conversar sobre lo que aprendimos gracias a tu participación.',
          termsCheckboxLabel:
            'Leí, entendí todo y estoy de acuerdo en participar.',
          termsAllowNewsLabel:
            'Quiero recibir novedades sobre los resultados de estas investigaciones y nuevos experimentos.',
          termsButton: 'Empezar',
          termsError: 'Es necesario aceptar los términos para continuar',

          /* Intro */
          introTitle:
            'A continuación te vamos a mostrar 6 escenarios imaginarios y hacerte algunas preguntas.',
          introText:
            'Por favor, leelos con atención y respondé qué opinás en cada caso. Podés ubicarte en el lugar de la escala que creas que mejor representa tu posición.',
          introButton: 'Empezar',

          /* Situations */
          situationTitle1: 'Imaginá el siguiente escenario:',
          situationTitle2: 'Siguiente escenario:',
          situationTitle3: 'Siguiente escenario:',
          situationTitle4: 'Siguiente escenario:',
          situationTitle5: 'Siguiente escenario:',
          situationTitle6: 'Último escenario:',
          situationTitle7: 'Siguiente escenario:',
          situationTitle8: 'Siguiente escenario:',
          situationTitle9: 'Último escenario:',
          whatDoYouThink: '¿Qué opinás?',

          wrong: 'Incorrecto',
          right: 'Correcto',

          confidenceQuestion: '¿Cuánto confias en tu respuesta?',
          personalEmotionalityQuestion:
            'Imaginate que se da esta situación y tenés que decidir qué hacer, ¿cuánta angustia sentirías?',
          entityEmotionalityQuestion:
            'Imaginate que se da esta situación y vos sos la persona responsable de decidir qué se va a hacer, ¿cuánta angustia sentirías?',

          nothing: 'Nada',
          alot: 'Mucho',
          notAnxious: 'Nada',
          anxious: 'Mucha',

          situationsButton: 'Siguiente',

          situation1_1:
            'Los respiradores artificiales se han convertido en un recurso crítico y un cuello de botella para los médicos en muchos países. Un comité de ética está considerando el criterio para decidir quienes accederán a este recurso y quiénes no. Una primera opción es asignar los respiradores según el orden de llegada a la guardia médica. La segunda opción sugiere que los pacientes más jóvenes (menores a 30 años) deben tener prioridad frente a los mayores, incluso si las chances de recuperación fuesen las mismas.',
          situation1_v1:
            'El comité de ética decide implementar la segunda opción.',
          situation1_1_question: 'Implementar la segunda opción es:',
          situation1_v2:
            'Imaginá la misma situación, pero ahora un paciente de 75 años ya está conectado a un respirador artificial. Un paciente de 30 años acaba de llegar a la sala de emergencia y ya no quedan más respiradores. El comité decide quitarle el respirador al paciente de 75 y dárselo al de 30.',
          situation1_2_question: 'Esta acción es:',
          situation1_v3:
            'Por último, el comité ahora decide que los trabajadores de la salud, como se infectaron ayudando a otra gente y son necesarios para seguir curando, deben tener prioridad en el acceso a respiradores por sobre cualquier otro paciente, sin importar la edad.',
          situation1_3_question: 'Esta decisión es:',

          situation2_1:
            'Imaginemos que podemos viajar en el tiempo e ir a un momento en el que la pandemia todavía no había explotado en el mundo. Una nueva tecnología permite que los gobiernos recolecten información personal acerca de nuestros movimientos y las personas con las que tuvimos contacto físico. Los gobiernos también pueden acceder a datos biométricos como nuestra temperatura y frecuencia respiratoria. Esta información permite identificar personas en riesgo de tener COVID-19 y limitar la propagación del virus seleccionando a quiénes aislar y a quiénes no.',
          situation2_2:
            'El gobierno del país donde vivís evalúa un plan de uso esta tecnología pero entiende que desprotege los datos personales de sus ciudadanos y decide no aprobarlo.',
          situation2_question: 'No aprobar el plan es:',

          situation3_1:
            'El futuro cercano de nuestras sociedades es incierto y todavía no sabemos cómo nos vamos a organizar cuando salgamos de períodos de cuarentena estricta. Esto es, entre otras cosas, porque desconocemos el ritmo de mutación del virus, su variación estacional, la probabilidad de re-contagio, y el grado de inmunidad que podremos alcanzar. Es probable que las sociedades lleguen a un compromiso entre minimizar riesgos a la salud y preservar nuestros estilos de vida deseados.',
          situation3_v1:
            'Sabiendo esto, un gobierno decide prohibir todo tipo de reuniones públicas (incluyendo restaurantes, bares, conciertos, cines y teatros) hasta que se encuentre una vacuna.',
          situation3_1_question: 'La decisión del gobierno es:',
          situation3_v2:
            'Un gobierno decide que, hasta que se encuentre una vacuna, toda persona que quiera viajar a otra ciudad debe pedirle un permiso oficial a una oficina pública del Estado.',
          situation3_2_question: 'Esta decisión del gobierno es:',
          situation3_v3:
            'Un gobierno decide implementar una cuarentena estricta para personas mayores a 70 años hasta que se encuentre una vacuna.',
          situation3_3_question: 'Esta decisión del gobierno es:',

          situation4_1:
            'Uno de tus amigos cercanos tiene fiebre alta y hace poco le hicieron el test de COVID-19. Las autoridades sanitarias de tu país le ordenaron que se quede en su casa en total aislamiento hasta que los resultados estén listos. Durante este período, tu amigo fue una vez a comprar comida al supermercado. Si las autoridades se enterasen de esto, tu amigo podría ir a la cárcel y tener antecedentes penales.',
          situation4_2:
            'Todavía no se sabe si el resultado del test es positivo pero decidiste llamar a la policía y contarle esta situación a las autoridades.',
          situation4_question: 'Contarle esta situación a las autoridades es:',

          situation5_1:
            'Un laboratorio tiene todos los recursos necesarios para desarrollar una vacuna para el coronavirus en tan sólo 4 semanas. Sin embargo, para hacer eso, los investigadores necesitan violar reglas éticas para el uso de animales en investigaciones científicas. En particular, los experimentos van a causar excesivo dolor y stress a cientos de roedores.',
          situation5_2:
            'El laboratorio pide un permiso excepcional para realizar estos experimentos, pero el gobierno decide rechazar este pedido.',
          situation5_question: 'La decisión tomada por el gobierno es:',

          situation6_1:
            'Muchos gobiernos les indicaron a sus ciudadanos que se queden en cuarentena en sus casas. Sin embargo, distintos países reaccionan de distinta manera a los incumplimientos de esta norma. Un gobierno decide que las personas que estén en un espacio público sin una razón válida deben ser llevadas a un centro de detención público y aisladas por 30 días.',
          situation6_question: 'La decisión tomada por el gobierno es:',

          situation7_1:
            'Varias clínicas privadas en un país compraron kits de diagnóstico de COVID-19. En un momento dado, la epidemia creció sustancialmente y el gobierno dejó de tener material suficiente para testear casos que considera urgentes.',
          situation7_2:
            'El gobierno decide expropiar por ley todos los kits de diagnóstico del país y otorgar una compensación a las clínicas que permite cubrir el costo de los materiales.',
          situation7_question: 'La decisión tomada por el gobierno es:',

          situation8_1:
            'Imaginemos que vivís en un país donde los efectos del coronavirus fueron relativamente suaves comparado con otros lugares del mundo. El gobierno acaba de anunciar el descubrimiento de una droga que resulta efectiva para curar el COVID-19. Varios otros países, donde el número de infectados sigue creciendo de modo exponencial y los efectos de la pandemia fueron más severos, desean comprar la droga.',
          situation8_2:
            'Sin embargo, el gobierno argumenta que el descubrimiento fue una inversión pública y decide prohibir la exportación de la droga, que no necesitan con urgencia en ese momento,  hasta que la enfermedad sea totalmente erradicada en el país. ',
          situation8_question: 'La decisión tomada por el gobierno es:',

          situation9_1:
            'Un tren fuera de control se dirige a toda velocidad por las vías hacia cinco personas que morirán si el tren sigue su curso. Vos estás a un costado de las vías, pero demasiado lejos para avisarles. Al lado tuyo hay una palanca de control que puede redirigir el tren hacia otra vía donde hay una sola persona.',
          situation9_2:
            'Si decidís accionar la palanca, eso provocará la muerte de una persona, pero el tren no seguirá su curso y habrás salvado la vida de otras cinco personas.',
          situation9_question: 'Accionar la palanca es:',

          situation10_1:
            'Un tren fuera de control se dirige a toda velocidad por las vías hacia cinco personas, que morirán si el tren sigue su curso. Vos estás a un costado de las vías, pero demasiado lejos para avisarles. Al lado tuyo hay otra persona que, en caso de que caiga a las vías, eso hará que el tren descarrile.',
          situation10_2:
            'Si decidís empujar a esta persona a las vías, eso provocará su muerte, pero el tren no seguirá su curso y habrás salvado la vida de otras cinco personas.',
          situation10_question: 'Empujar a la persona a las vías es:',

          /* Skip */
          skipTitle: '¡Perfecto! Completaste los 6 escenarios.',
          skipText:
            '¿Querés leer 3 escenarios más o preferís saltar al último paso?',
          skipReadMoreButton: 'Leer escenarios',
          skipLink: 'Saltar al último paso',

          /* Oxford */
          oxfordTitle: 'Últimas preguntas',
          oxfordText: 'Marcá cuán de acuerdo estás con las siguientes frases.',

          oxford1:
            'Si, durante una emergencia, la única manera de salvar la vida de otra persona es cortándose una pierna, entonces uno está moralmente obligado a hacer eso.',
          oxford2:
            'Desde el punto de vista moral, deberíamos sentirnos obligados a donar uno de nuestro riñones a una persona con insuficiencia renal dado que no necesitamos dos riñones para vivir y podemos ser saludables con uno solo. ',
          oxford3:
            'Desde una perspectiva moral, las personas deberían preocuparse igualmente por el bienestar de todos los seres humanos del planeta; no deberían favorecer el bienestar de las personas que son más cercanas, ya sea física o emocionalmente.',
          oxford4:
            'No ayudar a una persona está igual de mal que lastimarla activamente uno mismo.',
          oxford5:
            'Es moralmente incorrecto quedarse con plata que uno no necesita si uno la puede donar a causas que provean ayuda efectiva para personas que se beneficiarían mucho.',
          oxford6:
            'Es moralmente aceptable lastimar a una persona inocente si lastimarla es un medio necesario para ayudar a varias otras personas inocentes.',
          oxford7:
            'Si la única manera de asegurar el bienestar y la felicidad general de las personas es mediante la opresión política, limitada a un período corto en el tiempo, entonces se debe usar la opresión política.',
          oxford8:
            'Es permisible torturar a una persona inocente si esto fuese necesario para obtener información que evite la explosión de una bomba que mataría a cientos de personas.',
          oxford9:
            'A veces es moralmente necesario que las personas inocentes mueran como daño colateral, si al final se logra salvar la vida de más personas.',

          oxfordDisagree: 'Totalmente en desacuerdo',
          oxfordNeither: 'Ni en desacuerdo ni de acuerdo',
          oxfordAgree: 'Totalmente de acuerdo',

          oxfordButton: 'Siguiente',

          /* Regressors */
          regressorsTitle: 'Para terminar:',
          regressorsAge: 'Edad',
          regressorsGenre: 'Género:',
          regressorsGenrePlaceholder: 'Elegí una opción',
          regressorsNationality: 'Nacionalidad',
          regressorsCountry: '¿En qué país estás?',
          regressorsCountryPlaceholder: 'País',

          regressorsCovidQuestion:
            'Si conocés a alguien que tuvo o tenga COVID 19, marcá la o las opciones correspondientes:',
          regressorsCovidOption1: 'Yo tuve o tengo.',
          regressorsCovidOption2: 'Una persona cercana a mí tuvo o tiene.',
          regressorsCovidOption3:
            'Una persona que conozco, no muy cercana, tuvo o tiene.',
          regressorsCovidOption4: 'No conozco a nadie que haya tenido o tenga.',

          regressorsButton: 'Terminar',

          /* Thanks */
          thanksTitle: '¡Gracias por participar!',
          thanksLightText1:
            'En esta coyuntura tan particular, donde las sociedades se enfrentan a dilemas como los que acabás de atravesar, es importante entender la naturaleza de nuestra moral individual y colectiva. Tu participación ha sido fundamental en esta búsqueda.',
          thanksLightText2:
            'Estos problemas no tienen respuestas indefectiblemente correctas o incorrectas ni soluciones únicas. Creemos que el ejercicio de reflexionar sobre ellos ayuda a conocernos mejor y a ordenar nuestro pensamiento, de manera de poder tomar posiciones y decisiones conscientes e informadas.',
          thanksText:
            '¡Cuantas más personas participen, <1>mayor potencia tendrán los resultados!</1>',

          thanksContinue: 'Más experimentos pandémicos',

          /* Done */
          doneTitle: 'Gracias',
          doneLightText:
            'El experimento puede hacerse sólo una vez y ya tenemos tus respuestas.',

          doneShareText: 'No dejes de compartir ;)',
          doneContinue: 'Más experimentos pandémicos',

          /* Share */
          share: '<0>Compartí</0> el experimento',
          shareFacebookButton: 'Compartí en tu muro',
          shareTwitterButton: 'Escribí un tweet',

          /* Error Messages */
          errorFacebookLogin:
            'Hubo un error al ingresar con facebook, al reintentar revisa los permisos necesarios',
          errorGoogleLogin: 'Hubo un error al ingresar con google',

          errorMoveSlider: 'Es necesario mover el slider',
          errorMailUsed: 'Este mail ya está en uso',
          errorRequiredField: 'Este campo es requerido',
          errorMissingField: 'Falta responder alguna consigna',
          errorInformationRequired: 'Este campo es requerido',
          answerBeforeMovingOn: 'Falta responder alguna consigna',
          errorUserNotFound: 'No existe un usuario con ese email',
          errorInvalidEmail: 'No es un email válido',
          errorPasswordDontMatch: 'Las contraseñas no coinciden',
          errorWrongPassword: 'Contraseña incorrecta',
        },
      },
      // en: {
      //   translation: {
      //     /* Login */
      //     loginHello: '¡Hola!',
      //     loginTitle: 'Be part of a TEDxperiment',

      //     disclaimerWhy: 'Why do I have to log in?',
      //     disclaimerText:
      //       "You need to log in so we can make sure you won't repeat the experiment and that we don't take the same sample twice. All data is anonymized, used exclusively for scientific research and will be published openly (again, anonymized) and made available to the scientific community together with the corresponding publications.",

      //     loginFacebook: 'Log in with <1>Facebook</1>',
      //     loginGoogle: 'Log in with <1>Google</1>',

      //     loginEmailInput: 'Email',
      //     loginPasswordInput: 'Password',
      //     loginForgotPasswordLink: 'I forgot my password',

      //     loginButton: 'Log in',
      //     loginSignupQuestion: "You don't have an account yet?",
      //     loginSignupLink: 'Create account',

      //     /* Signup */
      //     signupTitle: 'Create account',
      //     signupNameInput: 'Name',
      //     signupEmailInput: 'Email',
      //     signupPasswordInput: 'Password',
      //     signupRepeatPasswordInput: 'Repeat password',

      //     signupButton: 'Create account',

      //     signupLoginQuestion: 'Already have an account?',
      //     signupLoginLink: 'Log in',

      //     /* Recover */
      //     recoverTitle: 'Account recovery',
      //     recoverText:
      //       'Enter your email address below and we will send you a link where you can enter a new password.',

      //     recoverEmailInput: 'Email',

      //     recoverButton: 'Restore',

      //     recoverSignupQuestion: "You don't have an account yet?",
      //     recoverSignupLink: 'Create account',

      //     recoverMailSent: 'We sent you an email',
      //     recoverMailSentText:
      //       'Check your email and click on the link we sent you to enter your new password.',

      //     /* New Password */
      //     newPasswordTitle: 'Create new password',
      //     newPasswordPasswordInput: 'New password',
      //     newPasswordConfirmPasswordInput: 'Repeat new password',
      //     newPasswordButton: 'Create password',

      //     /* Terms */
      //     termsTitle: 'Moral pandemic',
      //     termsText1:
      //       'You’re welcome to be part of a research project we’re conducting all over the world. Our aim is to study our moral intuitions and the decision making process in this very peculiar moment humanity is going through right now. This experiment is part of a study conducted by many TEDx events in different countries, El Gato y La Caja and the Torcuato Di Tella University’s Neuroscience Laboratory.',
      //     termsText2:
      //       'We will show you different dilemmas. Some of them can move us, or even distress us. We believe that the exercise of reflecting on them helps us to know ourselves better and to organize our thoughts.',
      //     termsText3:
      //       'You would be participating voluntarily. We’re asking for no more than 10 minutes of your time, but you are free to drop out at any moment. We don’t expect you’ll suffer any type of inconvenience or risk by participating. All responses and data gathered are absolutely confidential: everything is anonymized, encrypted and will be used exclusively for scientific research.',
      //     termsText4:
      //       'If you have any questions or comments, contact us at <1>labs@elgatoylacaja.com</1>. Beyond that channel, you can contact the ethics committee that approved this research: Comité de Ética en Investigación, Center for Medical Education and Clinical Research “Norberto Quirno”. Hospital Universitario sede Saavedra, Galván Ave. 4102. City of Buenos Aires, (C1425DQK) - Argentine Republic. Telephone: +54911 5299-0100, internal code: 2879.',
      //     termsText5:
      //       'As soon as the data analysis is ready, we’ll publish the results at <1>www.elgatoylacaja.com.ar/labs</1> to keep the conversation going.',
      //     termsCheckboxLabel:
      //       'I’ve read and understood and I agree to participate.',
      //     termsAllowNewsLabel: '',
      //     termsButton: 'Start',
      //     termsError: 'You need to check this box in order to continue',

      //     /* Intro */
      //     introTitle:
      //       'Up next, we’ll ask you some questions about 6 different hypothetical situations.',
      //     introText:
      //       'Read each of them carefully and give us your opinion. You can use the whole spectrum to give your answer.',

      //     introButton: 'Start',

      //     /* Situations */
      //     situationTitle1: 'Imagine the following situation:',
      //     situationTitle2: 'Imagine this situation:',
      //     situationTitle3: 'Imagine this situation:',
      //     situationTitle4: 'Imagine this situation:',
      //     situationTitle5: 'Imagine this situation:',
      //     situationTitle6: 'Last situation:',
      //     situationTitle7: 'Imagine this situation:',
      //     situationTitle8: 'Imagine this situation:',
      //     situationTitle9: 'Last situation:',
      //     whatDoYouThink: 'What do you think?',

      //     wrong: 'Wrong',
      //     right: 'Right',

      //     confidenceQuestion: 'How confident are you in your answer?',
      //     personalEmotionalityQuestion:
      //       'Imagine this situation happened and you are the person responsible for deciding what to do, how much distress would you feel?',
      //     entityEmotionalityQuestion:
      //       'Imagine this situation happened and you had to decide what to do, how much distress would you feel?',

      //     nothing: 'Not confident at all',
      //     alot: 'Very confident',
      //     notAnxious: 'None',
      //     anxious: 'A lot',

      //     situationsButton: 'Next',

      //     situation1_1:
      //       'Ventilators have become in many countries a limited resource and a medical bottleneck. An ethics committee (EC) is deciding how to set priorities on who will be treated and who will not. One option is to treat people on a first-come first-serve basis. A second argument is made that significantly younger patients (under 30 years old) should be prioritized and that, even when chances of recovery are considered to be the same, the younger patient should be treated before older patients.',
      //     situation1_v1: 'The EC opts to implement the second option.',
      //     situation1_1_question: 'Implementing the second option is:',
      //     situation1_v2:
      //       'Imagine the same situation, but now a 75-year-old patient is already on a ventilator. A 30-year old patient arrives at the ER and there are no more available ventilators.  The committee decides to remove the 75-patient from the ventilator to allow the 30-year old to be treated. ',
      //     situation1_2_question: 'This action is:',
      //     situation1_v3:
      //       'Lastly, the EC set a new criterion saying that health-care workers, because they got infected helping other people and they are necessary to continue treating more patients, should be given priority on access to ventilators over all other patients regardless of their age. ',
      //     situation1_3_question: 'This decision is:',

      //     situation2_1:
      //       'Suppose we can go back in time before the pandemic had exploded world-wide. A new technology allows governments to automatically collect personal information about our movements and the people we have physical contact with. Governments can also have access to biometric data such as our temperature and respiratory frequency. This allows identifying people at risk of having COVID-19 and limiting the propagation of the virus by selecting who is quarantined and who is not.',
      //     situation2_2:
      //       'The government of the country where you live evaluates a plan to use this technology but understands that it does not protect the personal data of its citizens and decides not to approve it.',
      //     situation2_question: 'Not approving the plan is:',

      //     situation3_1:
      //       'The near future of our societies and how we will get out of the periods of strict confinement is unclear, among other things because there are great unknowns in the mutation rates of the virus, its seasonal variance, the probability of being reinfected, and the degree of immunity that we will reach. Societies are likely to create a compromise between minimizing health risks and preserving our desired lifestyles.',
      //     situation3_v1:
      //       'Knowing this, a government decides to forbid all kinds of public gatherings (including restaurants, bars, concerts, cinemas and theatres) until a vaccine is found.',
      //     situation3_1_question: "The government's decision is:",
      //     situation3_v2:
      //       'Another government decides that, until a vaccine is found, people wishing to fly to other cities should request permission to an official public agency.',
      //     situation3_2_question: 'This decision made by the government is:',
      //     situation3_v3:
      //       'Lastly, another government decides to implement strict lockout policies for people older than 70 years old until a vaccine is found. ',
      //     situation3_3_question: 'This decision made by the government is:',

      //     situation4_1:
      //       'One of your close friends has high fever and was recently tested for COVID-19. The health authorities of your country have dictated that he should remain at home, in complete isolation, until the results are back. During this period, your friend went once to the supermarket to buy food. If the authorities find out about this, your friend might face prison and have a criminal record.',
      //     situation4_2:
      //       'You still do not know whether he will test positive for COVID-19 but decide to call the police and tell the authorities about this situation.',
      //     situation4_question:
      //       'Telling the authorities about this situation is:',

      //     situation5_1:
      //       'A laboratory has all the necessary resources to develop a vaccine against coronavirus in only 4 weeks. However, to do so, the researchers need to violate ethical guidelines for the use of animals in scientific research. Particularly, the experiments will cause excessive stress and pain to hundreds of rodents.',
      //     situation5_2:
      //       'The laboratory requests an exceptional permission to perform these experiments, but the government decides to reject this request.',
      //     situation5_question: 'The decision made by the government is:',

      //     situation6_1:
      //       'Many governments have instructed their citizens to rest at home, in confinement. However, different countries react in different ways to inflictions of this norm. A government decides that people found in a public space without a valid reason must be taken to a public detention facility and isolated for 30 days.',
      //     situation6_question: 'The decision made by the government is:',

      //     situation7_1:
      //       'Several private health companies in a given country bought test kits for COVID-19. At a given time, the epidemic has grown substantially, and the government does not have sufficient material to screen cases which they deemed urgent.',
      //     situation7_2:
      //       'The government decides to expropriate by law all diagnostic kits in the country, compensating the private companies for the costs of the materials.',
      //     situation7_question: 'The decision made by the government is:',

      //     situation8_1:
      //       'Imagine you live in a country where the effects of coronavirus have been relatively mild compared to other places in the World. The government has just announced the development of a drug that results in an effective cure against COVID-19. Several other countries, where infection keeps growing exponentially and the effects of the pandemic have been more severe, solicit to buy the drug.',
      //     situation8_2:
      //       'However, the government argues that the development was a public investment and decides to ban the exportation of the drug, even if at this point they do not urgently need all of it, until the disease is completely eradicated in the country.',
      //     situation8_question: 'The decision made by the government is:',

      //     situation9_1:
      //       'A runaway train is speeding down the tracks towards five people who will be killed if the train continues on its present course. You are standing next to the tracks, but you are too far away to warn them. Next to you there is a control switch that can redirect the train onto a different track, where there is only one person.',
      //     situation9_2:
      //       'If you decide to flip the control switch, that will provoke the death of one person, but the train will not continue its course and you will have saved the lives of five people.',
      //     situation9_question: 'Flipping the control switch is:',

      //     situation10_1:
      //       'A runaway train is speeding down the tracks towards five people who will be killed if the train continues on its present course. You are standing next to the tracks, but you are too far away to warn them. Next to you there is someone else and, if this person falls to the tracks, the train will derail.',
      //     situation10_2:
      //       'If you decide to push this person onto the tracks, that will provoke the death of this person, but the train will not continue its course and you will have saved the lives of five people.',
      //     situation10_question: 'Pushing the person onto the tracks is:',

      //     /* Skip */
      //     skipTitle: "Great! You've answered the 6 hypotheticals situations.",
      //     skipText:
      //       'Do you want to answer 3 more or would you rather skip to the last step?',
      //     skipReadMoreButton: "I'll do three more!",
      //     skipLink: 'Skip to last step',

      //     /* Oxford */
      //     oxfordTitle: 'Last questions',
      //     oxfordText: 'How much do you agree with the following statements?',

      //     oxford1:
      //       'If the only way to save another person’s life during an emergency is to sacrifice one’s own leg, then one is morally required to make this sacrifice.',
      //     oxford2:
      //       'It is morally right to harm an innocent person if harming them is a necessary means to helping several other innocent people.',
      //     oxford3:
      //       'From a moral point of view, we should feel obliged to give one of our kidneys to a person with kidney failure since we don’t need two kidneys to survive, but really only one to be healthy.',
      //     oxford4:
      //       'If the only way to ensure the overall well-being and happiness of the people is through the use of political oppression for a short, limited period, then political oppression should be used.',
      //     oxford5:
      //       'From a moral perspective, people should care about the well-being of all human beings on the planet equally; they should not favor the well-being of people who are especially close to them either physically or emotionally.',
      //     oxford6:
      //       'It is permissible to torture an innocent person if this would be necessary to provide information to prevent a bomb going off that would kill hundreds of people.',
      //     oxford7:
      //       'It is just as wrong to fail to help someone as it is to actively harm them yourself.',
      //     oxford8:
      //       'Sometimes it is morally necessary for innocent people to die as collateral damage—if more people are saved overall.',
      //     oxford9:
      //       'It is morally wrong to keep money that one doesn’t really need if one can donate it to causes that provide effective help to those who would benefit a great deal.',

      //     oxfordDisagree: 'Strongly Disagree',
      //     oxfordNeither: 'Neither Agree Nor Disagree',
      //     oxfordAgree: 'Strongly<1></1>Agree',

      //     oxfordButton: 'Next',

      //     /* Regressors */
      //     regressorsTitle: 'To wrap it up:',
      //     regressorsAge: 'How old are you?',
      //     regressorsGenre: 'Gender:',
      //     regressorsGenrePlaceholder: 'Choose an option',
      //     regressorsNationality: 'Nationality',
      //     regressorsCountry: 'In which country are you now?',
      //     regressorsCountryPlaceholder: 'Country',

      //     regressorsCovidQuestion:
      //       'If you know someone who has or has had COVID-19, check the answer(s) that apply.',
      //     regressorsCovidOption1: 'I have or have had it.',
      //     regressorsCovidOption2: 'A person close to me has or has had it.',
      //     regressorsCovidOption3:
      //       'I know of someone (not close to me) who has or has had it.',
      //     regressorsCovidOption4: "I don't know anyone who has or has had it.",

      //     regressorsButton: 'Finish',

      //     /* Thanks */
      //     thanksTitle: 'Thank you for participating!',
      //     thanksLightText1:
      //       'In this very particular context, where societies face dilemmas like the ones you have just been through, it is essential to understand the nature of our individual and collective principles. Knowing our biases and intuitions is the first step towards making conscious and informed decisions. Your participation has been essential in this search.',
      //     thanksLightText2: '',
      //     thanksText:
      //       "As more people take part, <1>we'll be able to find better insights!</1>",

      //     thanksContinue: '',

      //     /* Done */
      //     doneTitle: 'Thank you!',
      //     doneLightText:
      //       'The experiment can only be done once, we already have your answers. Help us by sharing the experiment so that many more people can do it.',

      //     doneShareText: "Don't forget to share it",
      //     doneContinue: '',

      //     /* Share */
      //     share: '<0>Share</0> the experiment',
      //     shareFacebookButton: 'Share it on your wall',
      //     shareTwitterButton: 'Write a tweet about it',

      //     /* Error Messages */
      //     errorFacebookLogin:
      //       'There was an error logging in with facebook, try again and check the permissions.',
      //     errorGoogleLogin:
      //       'There was an error logging in with google. Try again later, or try with another account.',

      //     errorMoveSlider: 'You need to move the slider',
      //     errorMailUsed: 'errorMailUsed',
      //     errorRequiredField: "Don't forget to answer this one!",
      //     errorMissingField: 'Make sure you answer all the statements.',
      //     errorInformationRequired: 'This information is required',
      //     answerBeforeMovingOn: 'Answer all the question before moving on.',
      //     errorUserNotFound:
      //       "The email you entered doesn't belong to an account. Please check your email and try again.",
      //     errorInvalidEmail:
      //       'The email you entered is not valid. Please check your email and try again.',
      //     errorPasswordDontMatch:
      //       "Your passwords don't match. Please double-check your passwords",
      //     errorWrongPassword:
      //       'Your password is incorrect. Please double-check your password.',
      //   },
      // },
    },
    fallbackLng: 'es',
    // debug: true,
  })

export default i18n
